export default {
    data() {
        return {
            labels: null,
            tips: '',
            isContinue: true,
            isContinues: true,
            classDetails: {
                period: '',
                image: '',
                name: '',
                price: '',
                onsale: '',
                teacher: ' ',
                desc: '',
                // project_id: '',
            },
            shoppingArr: [],
            labels: {
                id: '0'
            },
            labelsNoFirst: [],
            resources: [],
            // 是否购买过该课程
            isPay: '',
            // 课程包id
            categoryId: '',
        }
    },
    methods: {
        mouseOver(index, i) {
            this.$refs['btn' + index + i][0].style.background = "#DCECFD";
        },
        mouseLeave(index, i) {
            this.$refs['btn' + index + i][0].style.background = "#ffffff";
        },
        //判断是否已经购买过该课程
        byNow: function() {
            let categoryId = this.categoryId;


            // 1. 验证用户是否登录
            if (this.verifyLogin()) {
                // 没有登录, 跳转弹窗登录框
                this.$router.push({
                    path: "/personalcenter"
                });
                return;
            }

            // 2. 验证用户是否已购买该套餐
            // 请求用户state 为 2 的订单数据
            this.$post('orders/paid_order', {
                token: this.$store.state.id,
                offset: 0,
                length: 999
            }).then(res => {
                let list = res.data.result.data.map(item => item.id);

                // 发送订单数组和课程包id查出关联数据
                this.$post('category_order/search', {
                    category_ids: JSON.stringify([categoryId]),
                    order_ids: JSON.stringify(list),
                    offset: 0,
                    length: 999
                }).then(res2 => {
                    let list2 = res2.data.result.data;

                    if (list2.length === 0) {
                        // 用户没有购买过这个课程包
                        this.$router.push({
                            path: "/pay",
                            query: {
                                commodityList: JSON.stringify([categoryId])
                                // totalprices: price,
                                // categoryId: categoryId
                            }
                        });
                    } else {
                        this.$message.success(
                            "您已经购买了该套餐, 快去个人中心查看吧!"
                        );
                        this.isPay = 'true';
                        this.$route.query.isPay = 'true';
                    }
                });
            });
        },

        // 购买单个课程
        bySingleCourseNow(productId, price) {
            if (Number.parseFloat(price) == 0) {
                this.$post('orders/create', {
                    token: this.$store.state.id,
                    products: '[' + productId + ']',
                    pay_type: 1,
                    shop_id: this.$store.state.store.id
                }).then(res => {
                    if (res.data.status == 'success') {
                        return res.data.result;
                    }
                }).then(id => {
                    let time = this.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');
                    this.$post('orders/cancel', {
                        id: id,
                        token: this.$store.state.id,
                        state: '2',
                        pay_date: time
                    }).then(res => {
                        if (res.data.status == 'success') {
                            UIkit.modal(document.querySelector('#modal-free-class')).show();
                            this.$router.push({
                                path: '/personalcenter',
                            });
                        }
                    })
                })
            } else {
                let commodityList = [];
                let totalprices = price;
                commodityList.push(productId)
                this.$router.push({
                    path: '/pay',
                    query: {
                        commodityList: JSON.stringify(commodityList),
                        totalprices: totalprices,
                        type: 'single'
                    }
                });
            }
        },

        // 验证用户是否登录
        verifyLogin() {
            return this.$isAbnormal(this.$store.state.id);
        },

        //转化时间格式 yyyy-MM-dd hh:mm:ss
        formatDate: function(date, fmt) {
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
            }
            let o = {
                'M+': date.getMonth() + 1,
                'd+': date.getDate(),
                'h+': date.getHours(),
                'm+': date.getMinutes(),
                's+': date.getSeconds()
            };
            for (let k in o) {
                if (new RegExp(`(${k})`).test(fmt)) {
                    let str = o[k] + '';
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
                }
            }
            return fmt;
        },
        //转化时间格式
        padLeftZero: function(str) {
            return ('00' + str).substr(str.length);
        },

        //添加购物车
        addShoppingCart: function(id) {
            this.$post('shopping_cart/search', {
                token: this.$store.state.id,
                offset: '0',
                length: '999',
                shop_id: this.$store.state.store.id
            }).then(res => {
                let arr = [];
                for (let val of res.data.result.data) {
                    arr.push(Number.parseInt(val.product_id));
                }
                return arr;
            }).then(arr => {
                if (arr.indexOf(Number.parseInt(id)) == -1) {
                    this.$post('shopping_cart/create', {
                        product_id: id,
                        token: this.$store.state.id,
                        shop_id: this.$store.state.store.id
                    }).then(res => {
                        if (res.data.status == 'success') {
                            this.$store.state.shopNum += 1;
                            this.tips = '商品添加成功';
                            UIkit.modal(document.querySelector('#modal-buy')).show();
                        }
                    });
                } else {
                    this.tips = '购物车已经存在该商品，请勿重复添加';
                    UIkit.modal(document.querySelector('#modal-buy')).show();
                }
            })

        },
        //跳转回首页
        goIndex: function() {
            this.$router.push({
                path: '/'
            })
        },
        //获取课程详情的数据
        getData: function() {
            //获取传参的id
            let id = this.$route.query.id;
            //获取课程内容
            this.$post('products/get', {
                id: id
            }).then(res => {
                // console.log(res.data.result);
                document.title = res.data.result.name;
                this.classDetails = res.data.result;
                this.classDetails.id = id;
                return res.data.result.project_id;
            }).then(data => {
                this.$post('projects/search2', {
                    id: data,
                    offset: 0,
                    length: 999
                }).then(res => {
                    // 处理资源
                    let list = res.data.result.data;
                    let resources = [];
                    list.map(item => {
                        resources.push((JSON.parse(item.resources)[0]));
                    });
                    this.resources = resources;
                    console.log(this.resources);
                });

                // this.$post('projects/search', { id: data }).then(res => {
                // 	console.log(res)
                //     let arr = JSON.parse(res.data.result.resources);
                //     let newArr = arr.slice(0, arr.length - 1);
                //     let classArr = [];
                //     for (let val of newArr) {
                //         let obj = {
                //             name: val.name,
                //             className: val.items
                //         };
                //         classArr.push(obj)
                //     }
                //     this.resources = classArr;

                // })
            })


        },
        //全部课程跳转
        allClass: function() {
            this.$post('labels/all', {
                shop_id: this.$store.state.store.id
            }).then(res => {
                let data = res.data.result;
                this.allLabel(data, this.labels);
                return true;
            }).then(() => {
                for (let item of this.labels.children) {
                    if (item.children) {
                        for (let val of item.children) {
                            this.labelsNoFirst.push(val);
                        }
                    }
                }
                this.$router.push({
                    path: '/blank',
                    query: {
                        lableData: JSON.stringify(this.labelsNoFirst),
                        firstName: '全部',
                        firstId: 0,
                        lableType: 'firstLable',
                    }
                })
            })
        },
        //递归处理返回的标签
        allLabel(data, labelObj) {
            for (let i in data) {
                if (data[i].parent_id === labelObj.id) {
                    if (!labelObj.children) {
                        labelObj.children = [];
                    }
                    labelObj.children.push(data[i]);
                    this.allLabel(data, data[i]);
                }

            }
        },

        // 前往个人中心
        toCenter() {
            this.$router.push({
                path: '/personalcenter'
            })
        }

    },
    mounted: function() {
        this.getData();

        // 获取是否购买
        this.isPay = this.$route.query.isPay;

        // 获取课程包id
        this.categoryId = this.$route.query.category_id;
    },
}